<ng-content select="kb-footer-link" /> <!-- https://github.com/angular/angular/issues/50543 -->

<ng-content select="kb-extended-footer" />
<nav class="meta-navigation" [attr.aria-label]="metaNavigationLabel">
  <ul>
    @for (link of links(); track link.href) {
      <li>
        <a kb-link [kbRouterOrExternalLink]="link.href" [attr.target]="link.target">
          <ng-container *ngTemplateOutlet="link.content()" />
        </a>
      </li>
    }
  </ul>
</nav>
